import i18n from '@/i18n'

export default {
  accountProductHeaders () {
    return [
      {
        text: i18n.t('name'),
        value: 'name'
      },
      {
        text: '',
        value: 'isScalable',
        align: 'center',
        sortable: false,
        width: 48
      }
    ]
  }
}
